import { useEffect, useState } from "react";
import { Globe, Smartphone } from "lucide-react";
import { api } from "@/lib/api";

const ago = (iso) => { const s = Math.max(0, Math.round((Date.now() - new Date(iso)) / 1000)); return s < 60 ? `${s} sn önce` : `${Math.round(s / 60)} dk önce`; };

export function OnlineList({ onPick }) {
  const [res, setRes] = useState(null);
  useEffect(() => {
    const load = () => api.get("/takip/online").then(({ data }) => setRes(data)).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);
  return (
    <div className="panel p-3 min-w-0" data-testid="online-list">
      <div className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-wider text-slate-500 mb-2">
        <span className="relative flex h-2 w-2"><span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" /><span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" /></span>
        Şu an çevrimiçi <span className="text-slate-400 normal-case font-normal">(son {res?.minutes || 5} dk)</span></div>
      {!res ? <div className="h-16 animate-pulse bg-slate-50 rounded" /> : res.items.length === 0 ? <div className="text-[12px] text-slate-400">Kimse yok</div> : (
        <ul className="space-y-2">{res.items.map((u) => (
          <li key={u.user_id}><button className="w-full text-left hover:bg-slate-50 rounded p-1 -m-1" onClick={() => onPick?.(u.user_id)} data-testid={`online-user-${u.user_id}`}>
            <div className="flex items-center justify-between gap-2"><span className="text-[13px] font-medium truncate">{u.user_name}</span>
              <span className="text-[10px] text-slate-400 whitespace-nowrap flex items-center gap-1">{u.platform === "mobil" ? <Smartphone className="h-3 w-3" /> : <Globe className="h-3 w-3" />}{ago(u.last_activity)}</span></div>
            <div className="text-[11px] text-slate-500 truncate">{u.summary}</div></button></li>))}</ul>)}
    </div>
  );
}
